import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';

export const TAX_YEAR_START_SCHEMA = Object.freeze({
  MONTH: 1,
  DAY: 1,
});
const RECORD = generateSchema(TAX_YEAR_START_SCHEMA);
const KEYS: any = generateKeys(TAX_YEAR_START_SCHEMA);

export class TaxYearStart extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get month(): number {
    return this.get(KEYS.MONTH);
  }

  get day(): number {
    return this.get(KEYS.DAY);
  }
}
